export default "__VITE_ASSET__BMwUfCnX__"